import React from "react";
import styles from "./styles.module.scss";
import HeaderSection from "../HeaderSection";

const aboutData = [
  {
    id: 1,
    title: "Hey there, I'm Mahmoud.",
    icon: "👋",
  },
  {
    id: 2,
    title:
      " With over 3 years of experience: * Developing and programming interfaces using JavaScript, React, React Native, and NextJS. * Server-side development using NodeJS and the ASP.NET, coupled with MySQL and NoSQL databases.",
    icon: "👨‍💻",
  },
  {
    id: 3,
    title:
      "I have a keen interest in front-end development using React and NextJS.",
    icon: "💡",
  },
  {
    id: 4,
    title:
      "Striving to improve a little every day, aspiring to be better than yesterday.",
    icon: "🚀",
  },
];
const About = () => {
  return (
    <>
      <HeaderSection title={"About Me"} id="about"/>
      <section className="mt-4 mb-3" >
        {aboutData.map((el) => (
          <div className={`mb-3 ${styles.aboutText}`} key={el.id}>
            {el.icon} {el.title}
          </div>
        ))}
      </section>
    </>
  );
};

export default About;
